import { render } from "./YMMComponent.vue?vue&type=template&id=004fc9f6&scoped=true"
import script from "./YMMComponent.vue?vue&type=script&lang=js"
export * from "./YMMComponent.vue?vue&type=script&lang=js"

import "./YMMComponent.vue?vue&type=style&index=0&id=004fc9f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004fc9f6"]])

export default __exports__